var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoClosed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2042 4.94366L35.2394 23.2606C35.7465 21.6127 36 19.838 36 18C36 8.0493 27.9507 0 18 0C8.04929 0 0 8.11268 0 18C0 23.0704 2.09155 27.6972 5.51408 30.9296H5.57747V30.993C8.80986 34.0986 13.1831 36 18 36C25.162 36 31.3099 31.8169 34.2254 25.7958L26.2394 4.94366H28.2042Z",
    fill: "#FADB5D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoClosed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-closed.77609ce7dc7fd1d2bd2fbac2917097f1.svg";